<template>
    <div class="filter-box">
      <searchUser class="search" v-on:changeUsersFilter="changeUsersValue"/>
    </div>
</template>

<script>
import searchUser from '../common/filters/users/UserSearch'
export default {
  name: 'UsersFilter',
  components: {searchUser},
  methods: {
    changeUsersValue () {
      this.$emit('changeUsersFilter')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/users/UsersFilter.vue